import React from 'react';
import Layout from '../components/Layout';
import Kvad from './Kvad';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';
import styled from 'styled-components';
import {breakPoint} from '../styles/var';
import ScrollLink from '../components/ScrollLink';
import Img from '../components/Img';

import btn_1 from '../assets/img/pc02-11.png';
import btn_2 from '../assets/img/pc02-12.png';

const FixedBtnStyles = styled.div`
  position: fixed;
  right: 0;
  bottom: 30%;
  width: 20%;
  z-index: var(--level1);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2rem;
  @media (min-width: ${breakPoint.min}) {
    width: 12%;
  }
  @media (max-width: ${breakPoint.smMax}) {
    gap: 1rem;
  }
`;


const App = () => {
    return (
        <Layout>
            <Kvad id="Section1"/>
            <Section1/>
            <Section2 id="Section2"/>
            <Section3 id="Section3"/>
            <Section4 id={"Section4"}/>
            <Section5 id={"Section5"}/>
            <Section6 id={"Section6"}/>
            <FixedBtnStyles>
                <ScrollLink to={"Section2"}>
                    <Img src={btn_1} />
                </ScrollLink>
                <ScrollLink to={"Section3"}>
                    <Img src={btn_2} />
                </ScrollLink>
            </FixedBtnStyles>
        </Layout>
    );
}

export default App;
